module.exports = __webpack_public_path__ + "static/media/logo-text.d974274f.svg";